import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, categoryType, redirectingProfileEnum } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total Value (USD)", two_table_header: "Total Value (USD)" },
  { value: "weight", label: "Total Weight (kg)", two_table_header: "Total Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];
export const defaultData = {
  name: "Uruguay Imports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  showUiTrends: true,
  isViewAllGridNew: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("uruguayImportLatestArrivalDate"),
    getSearchResult: getApiUrl("uruguayImportSearch"),
    getAnalyticsData: getApiUrl("analytics/uruguayImportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_uruguay_imports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_uruguay_imports"),
    getShipmentByID: getApiUrl("uruguayImportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfUruguayImports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/uruguayImportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("importerExporterGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.uy_import.country_small,
  countryCaps: globalCountryDetails.uy_import.country_caps,
  product_id: globalCountryDetails.uy_import.product_id,
  compare_product_id: globalCountryDetails.uy_import.compareProduct,
  country_CamelCase: globalCountryDetails.uy_import.product_id,
  countryCode: globalCountryDetails.uy_import.countryCode,
  countryType: globalCountryDetails.uy_import.countryType,
  manyCountryType: globalCountryDetails.uy_import.manyCountryType,
  countryTypeCode: globalCountryDetails.uy_import.countryTypeCode,
  redirectionID: globalCountryDetails.uy_import.redirectionID,
  analyticsCountryID: globalCountryDetails.uy_import.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipments Arrival Date Range",
  monthRangeHeading: "Month of Import",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: false,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: false,
    product_hscode: true,
    exporters: false,
    importers: true,
    allCategory: true,
    ports: true,
  },
  searchCategoryList: globalCountryDetails.uy_import.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    productCategory: "productCategory",
    value: "shipmentValue",
    sixDigitHsCode: "sixDigitHsCode",
    // portOfLading: "standardLadingPortName",
    portOfUnlading: "standardUnladingPortName",
  },
  filterObj: {
    derivedCountryOfOriginEnglishRegion: "derivedCountryOfOriginEnglishRegion",
    derivedCountryOfProvenanceEnglishRegion: "derivedCountryOfProvenanceEnglishRegion",
    countryOfDestinationRegion: "countryOfDestinationRegion",
    derivedImporterName: "derivedImporterName",
    isImporter: "isImporter",
    standardUnladingPortName: "standardUnladingPortName",
    derivedModeOfTransportEnglish: "derivedModeOfTransportEnglish",
    hsCode: "hsCode",
    weight: "weight",
    shipmentValue: "shipmentValue",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    incoterm: "incoterm",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    derivedCountryOfOriginEnglishRegion: "derivedCountryOfOriginEnglish",
    derivedCountryOfProvenanceEnglishRegion: "derivedCountryOfProvenanceEnglish",
    countryOfDestinationRegion: "countryOfDestination",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
  },
  emptyFilterObj: {
    derivedCountryOfOriginEnglishRegion: [],
    derivedCountryOfProvenanceEnglishRegion: [],
    countryOfDestinationRegion: [],
    derivedImporterName: [],
    isImporter: [],
    standardUnladingPortName: [],
    derivedModeOfTransportEnglish: [],
    hsCode: [],
    weight: [],
    shipmentValue: [],
    sections: [],
    derivedConsigneeMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    consigneeJurisdictionCountryRegion: [],
    incoterm: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    derivedCountryOfOriginEnglishRegion: false,
    derivedCountryOfProvenanceEnglishRegion: false,
    countryOfDestinationRegion: false,
    derivedImporterName: false,
    isImporter: false,
    standardUnladingPortName: false,
    derivedModeOfTransportEnglish: false,
    hsCode: false,
    weight: false,
    shipmentValue: false,
    sections: false,
    derivedConsigneeMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    consigneeJurisdictionCountryRegion: false,
    incoterm: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: categoryType.consigneeDetails, eventKey: "16", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee name", categoryName: categoryType.consigneeDetails, eventKey: "3", key: "derivedImporterName", type: filterType.normalFilter, label: "Consignee name", viewAllPlaceHolder: "Search in Consignee name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Importer Type", categoryName: categoryType.consigneeDetails, eventKey: "10", key: "isImporter", type: filterType.normalFilter, label: "Importer Type", viewAllPlaceHolder: "Search in Importer Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Origin", categoryName: categoryType.shipperDetails, eventKey: "1", key: "derivedCountryOfOriginEnglishRegion", altKey: "derivedCountryOfOriginEnglish", type: filterType.localizeFilter, label: "Country Of Origin", viewAllPlaceHolder: "Search in Country Of Origin Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: categoryType.shipperDetails, eventKey: "2", key: "derivedCountryOfProvenanceEnglishRegion", altKey: "derivedCountryOfProvenanceEnglish", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: categoryType.consigneeDetails, eventKey: "2", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Office", categoryName: categoryType.ports, eventKey: "4", key: "standardUnladingPortName", type: filterType.normalFilter, label: "Customs Office", viewAllPlaceHolder: "Search in Customs Office Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: categoryType.freightType, eventKey: "5", key: "derivedModeOfTransportEnglish", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: categoryType.cargoDetails, eventKey: "6", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: categoryType.cargoDetails, eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: categoryType.cargoDetails, eventKey: "6", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight (kg)", categoryName: categoryType.cargoDetails, eventKey: "7", key: "weight", type: filterType.boxFilter, label: "Weight (kg)", viewAllPlaceHolder: "Search in Weight Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "8", key: "shipmentValue", type: filterType.boxFilter, label: "Shipment Value (USD)", viewAllPlaceHolder: "Search in Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: categoryType.cargoDetails, eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    { heading: "Filter by Incoterm", categoryName: categoryType.freightType, eventKey: "22", key: "incoterm", type: filterType.normalFilter, label: "Incoterm", viewAllPlaceHolder: "Search in Incoterm Filter", emptyFilterText: "", searchFilterString: "", isNoTransform: true },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "derived_importer_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Name" },
    { key: "derived_rut_number", label: "Consignee RUT Number" },
    { key: "hs_code", label: "HS Code" },
    { key: "dua", label: "Single Customs Document (DUA)" },
    { key: "import_id", label: "DUA" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_port_of_lading", label: "Port of Lading" },
    { key: "derived_custom_office_name", label: "Custom Office" },
  ],
  shipmentSorting: [
    { columnKey: "date", value: "date", isDefault: true },
    { columnKey: "net_weight_item_kgs", value: "weight", isDefault: false },
    { columnKey: "customs_value_item_usd", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  importerSorting: [
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
  ],
  sortKeyMap: {
    date: "date",
    weight: "net_weight_item_kgs",
    shipment_value: "customs_value_item_usd",
  },
  sortKeyUniqueImpExpMap: {
    shipment_value: "shipment_value",
    date: "doc_count",
    weight: "weight",
  },
  analyticsHeaderItems: [
    { label: "Total Shipments Imports", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipments Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
    { label: "Total Shipments Value", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "derivedCountryOfProvenanceEnglishRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Import Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "derived_country_of_origin_english", filterKey: "derivedCountryOfOriginEnglishRegion", label: "Countries of Origin", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_provenance_english" },
    { key: "derived_country_of_provenance_english", filterKey: "derivedCountryOfProvenanceEnglishRegion", label: "Countries of Export", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin_english" },
    { key: "derived_custom_office_entry_name", filterKey: "standardUnladingPortName", label: "Customs Offices", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin_english", profileType: redirectingProfileEnum.portOfUnlading.key },
    // { key: "trade_country", filterKey1: "standardUnladingPortName", filterKey2: "derivedCountryOfOriginEnglishRegion", label: "Trade Routes (Customs Offices -> Countries of Origin)", headerOne: "Customs House", headerTwo: "Country of Origin", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "derived_mode_of_transport_english", filterKey: "derivedModeOfTransportEnglish", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "derived_country_of_origin_english" },
    { key: "trade_port", filterKey1: "derivedCountryOfOriginEnglishRegion", filterKey2: "derivedCountryOfProvenanceEnglishRegion", filterKey3: "standardUnladingPortName", label: "Trade Routes (Countries of Origin → Countries of Export → Customs Office)", headerOne: "Country of Origin", headerTwo: "Countries of Export", headerThree: "Customs Office", filterOne: "filterField1", filterTwo: "filterField2", filterThree: "filterField3", keyOne: "field1Country", keyTwo: "field2Country", keyThree: "field3Country", cityOne: "field1", cityTwo: "field2", cityThree: "field3", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", keyThreeCountryCode: "field3CountryCode", type: analyticsType.topThree, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "2-digit HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "date", name: "Shipment Date", selector: "date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "" },
    { key: "derived_commercial_item_quantity", name: "Quantity", selector: "derived_commercial_item_quantity", secondarySelector: "derived_commercial_item_measurement_unit", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "net_weight_item_kgs", name: "Net Weight (kg)", selector: "net_weight_item_kgs", dataTip: "", type: "", sortable: true, grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true },
    { key: "derived_country_of_export_english", name: "Country Of Export", selector: "derived_country_of_export_english", dataTip: "", type: "", grow: 1, wrap: true },
    { key: "shipment_value", altKey: "customs_value_item_usd", name: "Shipment Value (USD)", selector: "customs_value_item_usd", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "weight", name: "Gross Weight (kg)", selector: "weight", sortable: true, dataTip: "", grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Shipment Value (USD)", selector: "shipment_value", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: false, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Shipment Date", value: "date", dateFormat: true, monthFormat: false },
        { label: "Single Customs Document (DUA)", value: "import_id", capitalize: true },
        { label: "Item No.", value: "item_count" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport" },
        { label: "HS Code", value: "hs_code" },
        { label: "Incoterm", value: "derived_incoterm_english", capitalize: true, tooltip: true, tooltipField: "derived_incoterm_english", tooltipPrefix: "" },
        { label: "Purpose of Import", value: "derived_import_type_english", tooltip: true, tooltipField: "import_type_spanish", tooltipPrefix: "" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Origin", value: "derived_country_of_origin_english", countryFlag: true, countryCodeField: "country_of_origin_code", tooltip: true, tooltipField: "derived_country_of_origin" },
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code", tooltip: true, tooltipField: "derived_country_of_export" },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee name", value: "derived_importer_name", tooltip: true, tooltipField: "country_of_destination", tooltipPrefix: "Country Code: ", countryFlag: true, countryCodeField: "country_of_destination_code" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "", derivedCompanyKey: "derived_consignee_master_name" },
        { label: "Consignee RUT Number", value: "derived_rut_number" },
        { label: "Consignee Type", value: "derived_is_importer" },
        { label: "Customs Office", value: "derived_custom_office_name", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "DUA Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "DUA Id", value: "import_id" },
        { label: "CIF Value DUA", value: "customs_value_dua_usd", valuePrefix: "USD ", isCommaFormat: true, fixedValueUpto: 2 },
        { label: "Net Weight DUA", value: "net_weight_dua_kgs", valueSuffix: " kg", isCommaFormat: true, fixedValueUpto: 2 },
        { label: "Gross Weight DUA ", value: "gross_weight_dua_kgs", valueSuffix: " kg", isCommaFormat: true, fixedValueUpto: 2 },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Item Number", value: "item_number" },
        { label: "HS Code", value: "hs_code" },
        { label: "CIF Value", value: "customs_value_item_usd", valuePrefix: "USD ", isCommaFormat: true },
        { label: "FOB Value of Item", value: "fob_value", valuePrefix: "USD ", unitField: "commercial_unit", dynamicUnit: true, unitField2: "", dynamicUnit2: false, tooltip: false, tooltipField: "", tooltipField2: "", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Freight Value", value: "freight_value", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Insurance Value", value: "insurance_value", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Net Weight", value: "net_weight_item_kgs", valueSuffix: " kg", isCommaFormat: true },
        { label: "Commercial Item Quantity", value: "derived_commercial_item_quantity", unitField: "derived_commercial_item_measurement_unit", dynamicUnit: true, isCommaFormat: true },
        { label: "Physical Item Quantity", value: "derived_physical_item_quantity", unitField: "derived_physical_item_measurement_unit", dynamicUnit: true, isCommaFormat: true },
      ],
    },
  ],
  defaultUeUiSecondLevelKey: "derived_consignee_master_name",
  twoColumnMapping: {
    derived_consignee_master_name: "Unique Importers",
    // derived_shipper_master_name:"Unique Exporters",
    derived_country_of_origin_english: "Countries of Origin",
    derived_country_of_provenance_english: "Countries of Export",
    derived_custom_office_entry_name: "Customs Offices",
    // trade_country: "Trade Routes (Customs Offices -> Countries of Origin)",
    derived_mode_of_transport_english: "Mode of Transportation",
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    trade_port: "Trade Routes (Countries of Origin   Customs Offices → Countries of Export)",
    sections: "Section",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const PanamaImportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default PanamaImportSearch;
